import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=686660c4&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=686660c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686660c4",
  null
  
)

export default component.exports